import React from "react";

import { useInlet } from "context/inletContext";
import { useApp } from "context/appContext";
import { checkReservation } from "services/event.service";
import * as Status from "constants/statusBooking";
import ReservationForm from "components/ReservationForm";

function Assistants() {
  const {
    reservation,
    setReservation,
    setLoading,
    setShowSuccess,
    setShowCamera,
    setBookings,
  } = useInlet();
  const { showNotification } = useApp();
  const handleChangeStatus = (id, value) => {
    let clone = JSON.parse(JSON.stringify(reservation));
    clone.assistants.forEach((assistant) => {
      if (assistant.id === id) {
        assistant.state = value ? Status.PENDING : Status.RESERVED;
      }
    });
    setReservation(clone);
  };

  const save = async () => {
    try {
      setLoading(true);
      const booking = await checkReservation(reservation);
      setBookings(booking);
      setShowCamera(true);
      setLoading(false);
      setShowSuccess(true);
    } catch (error) {
      showNotification("Ha ocurrido un error registrando al información en el servidor", "error");
      setShowCamera(true);
      setLoading(false);
    }
    setTimeout(() => setShowSuccess(false), 1000);
  };
  const cancel = () => {
    setShowCamera(true);
  };
  return (
    <ReservationForm
      reservation={reservation}
      onCancel={cancel}
      cancel
      check
      onSave={save}
      onEditItem={handleChangeStatus}
      big
    />
  );
}

export default Assistants;
